(ns frontend.ui.component.lp-portal.report.body.private-equity.pdf.view.overview
  (:require
   [frontend.ui.component.chart.view :as chart-view]
   [frontend.ui.component.lp-portal.big-figure.pdf.view :as big-figures]
   [frontend.ui.component.lp-portal.card.pdf.view :refer [card]]
   [frontend.ui.component.lp-portal.column.pdf.view :refer [column columns columns-2-to-1]]
   [frontend.ui.component.lp-portal.page.pdf.view :as page]
   [frontend.ui.component.lp-portal.text-content.pdf.view :as text-content]
   [frontend.ui.component.lp-portal.table.pdf.view :as table]
   [potpuri.core :as potpuri]))

(defn- recent-development-figures
  [recent-development]
  {:stack [(->> recent-development
                :figures
                (table/dynamic-stack))
           (text-content/optional-footer recent-development)]})

(defn- recent-development-page
  [report-data]
  (let [{:keys [recent-development recent-development-text overview-figures]} (-> report-data
                                                                                  :overview)]
    (page/page
     (page/third-column-background)
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview" :toc-item true})
     (columns-2-to-1
      (card
       "Recent Development"
       (text-content/rich-content (:rich-content recent-development-text)))
      (card
       nil
       (big-figures/table (:figures overview-figures) 2)
       (text-content/optional-footer overview-figures)
       (recent-development-figures recent-development))))))

(defn- charts-page
  [report-data]
  (let [{:keys [total-investment portfolio-at-fair-value historical-net-cash-flows]} (-> report-data
                                                                                         :overview)]
    (page/page
     (page/page-title {:fund-name (:fund-name report-data) :page-title "Overview"})
     {:stack
      ;; calculate footers spacing need ->>
      ;; ->> resize chart heights accordingly
      [(columns
        (card
         "Total investment"
         {:svg   (chart-view/chart-svg "highcharts"
                                       (potpuri/deep-merge
                                        (:figures total-investment)
                                        {:chart {:width  800
                                                 :height 360}}))
          :width 400}
         (text-content/optional-footer total-investment))
        (card
         "Portfolio at fair value"
         {:svg   (chart-view/chart-svg "highcharts"
                                       (potpuri/deep-merge
                                        (:figures portfolio-at-fair-value)
                                        {:chart {:width  800
                                                 :height 360}}))
          :width 400}
         (text-content/optional-footer portfolio-at-fair-value)))
       (column
        (card
         "Historical net cash flows"
         {:svg       (chart-view/chart-svg "highcharts"
                                           (potpuri/deep-merge
                                            (:figures historical-net-cash-flows)
                                            {:chart {:width  1600
                                                     :height 460}}))
          :width     800
          :alignment :center}
         (text-content/optional-footer historical-net-cash-flows)))]})))

(defn overview-pages
  [report-data]
  [(recent-development-page report-data)
   (charts-page report-data)])
